import { createContext } from 'react';
import { IAuthService } from './components/Auth/AuthService';
import { AuthHelper } from './components/Auth/AuthHelper';

export interface IAppContext {
  get ApiVersion (): string;
  init (): Promise<any>;
  get AuthService (): IAuthService;
}

export class AppContext implements IAppContext {
  private _apiVersion: string = '';
  private _authService?: IAuthService;

  async init (): Promise<any> {
    if (!this._authService) {
      const authService = AuthHelper.getAuthService();
      if (!authService) {
        return;
      }
      this._authService = authService;
      await this._authService.init();
      const token = await this._authService.acquireAccessToken();
      AuthHelper.saveAccessToken(token);
    }
  }

  get ApiVersion (): string {
    return this._apiVersion;
  }

  get AuthService (): IAuthService {
    return this._authService!;
  }
}

export const appContextInstance: IAppContext = new AppContext();
export const AppReactContext = createContext<IAppContext>(appContextInstance);
